import { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const SessionMonitor = () => {
  const navigate = useNavigate();

  const parseJwt = (token) => {
    try {
      return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
      return null;
    }
  };

  // Envolvemos la función en useCallback
  const logout = useCallback(() => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    alert("Tu sesión ha expirado por seguridad.");
    navigate('/login');
  }, [navigate]); // navigate es la única dependencia aquí

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    const decoded = parseJwt(token);
    if (!decoded || !decoded.exp) {
      logout();
      return;
    }

    const expirationTime = decoded.exp * 1000;
    const currentTime = Date.now();
    const timeRemaining = expirationTime - currentTime;

    if (timeRemaining <= 0) {
      logout();
    } else {
      const timer = setTimeout(() => {
        logout();
      }, timeRemaining);

      return () => clearTimeout(timer);
    }
  }, [logout]); // Ahora podemos agregar logout al array sin problemas

  return null;
};

export default SessionMonitor;